import { useParams } from 'react-router-dom';

export const useServiceCatalogId = () => useParams<Dictionary<string>>().id!;
